import { apis } from "config/urls";
import { getAPI } from "utils/http";

export async function fetchSupplyDemandData({ productId, token, version }) {
  const res = await getAPI(
    apis.GWAPI,
    {
      getSummaryTable: productId,
      version: version,
    },
    token
  );
  if (
    res.status === 200 &&
    (res.data.query_type !== "table" || res.data.name !== "summary")
  ) {
    console.log("Error: can not get summary table");
    return false;
  }
  return res;
}

export async function supplyAndDemandGetProductById({ productId, token }) {
  const res = await getAPI(
    apis.GWAPI,
    {
      op_code: "get_product_by_id",
      product_id: Number(productId),
      offset: 0,
      count: 100,
    },
    token
  );
  return res;
}

export function getProductId({ urlSearchParams }) {
  const urlParams = new URLSearchParams(urlSearchParams);
  const product_id = urlParams.get("product_id");
  return product_id;
}
